<template>
  <b-modal
    id="zone-pricing-dialog"
    ref="modal"
    :title="$t('vehicles.field_groups.zone_pricing')"
    :ok-disabled="adding"
    :cancel-disabled="adding"
    :hide-header-close="adding"
    :no-close-on-backdrop="adding"
    :no-close-on-esc="adding"
    size="lg"
    centered
  >
    <b-card v-if="adding" :header="$t('general.add_new')">
      <vehicle-zone-price-form
        :vehicle-id="vehicleId"
        @saved="onCreated"
        @cancelled="adding = false"
      />
    </b-card>
    <b-button
      v-if="!adding"
      variant="light"
      class="mb-2"
      @click="adding = !adding"
    >
      {{ $t('general.add_new') }}
    </b-button>
    <admin-table
      ref="table"
      :api-builder="apiBuilder"
      :columns="columns"
      :row-actions="['details', 'delete']"
      :bulk-actions="[]"
      :search-fields="null"
    >
      <template slot="pricing.one_way" slot-scope="{ item }">
        <value-price-with-currency :item="{priceInBaseCurrency: item.pricing.one_way}"  attribute="pricing.one_way"/>
      </template>
      <template slot="row-details" slot-scope="{ item }">
        <vehicle-zone-price-form
          :vehicle-id="vehicleId"
          :id="item.id"
          @saved="onUpdated"
          @cancelled="item._showDetails = false"
        />
      </template>
    </admin-table>
  </b-modal>
</template>

<script>
import { AdminTable } from 'stylemix-vue-admin'
import VehicleZonePriceForm from './Form'
import PriceZonesApi from './Api'

export default {
  name: 'ZonePricing',

  components: {
    AdminTable,
    VehicleZonePriceForm,
  },

  props: {
    vehicleId: { type: [Number, String], required: true },
  },

  data: () => ({
    adding: false,
  }),

  computed: {
    columns() {
      return [
        {
          key: 'zone.name',
          label: this.$t('vehicles.attributes.zone_id.label'),
        },
        {
          key: 'pricing.one_way',
          label: this.$t('vehicles.attributes.pricing.one_way.label'),
        },
        {
          key: 'pricing.return',
          label: this.$t('vehicles.attributes.pricing.return.label'),
        },
        {
          key: 'condition_label',
          label: this.$t('vehicles.attributes.condition.label'),
        },
      ]
    },
  },

  methods: {
    apiBuilder() {
      return new PriceZonesApi(this.vehicleId)
    },
    onCreated() {
      this.adding = false
      this.$refs.table.refresh()
    },
    onUpdated() {
      this.$refs.table.refresh()
    },
  },
}
</script>
